import Button from 'components/button';

const PrerequisitesSection = ({ dataCreateMission, setPage }) => (
  <div className="mx-6 border-b border-gray-200 py-2">
    <div className="flex justify-between">
      <span className="ft-b text-gray-900 font-medium">Pré-requis</span>
      <Button color="DEFAULT" size="SM" onClick={() => setPage(1)}>
        Modifier
      </Button>
    </div>
    <div>
      <p className="ft-sm">
        <span className="text-gray-700 font-medium">Matériel nécessaire :</span>{' '}
        {dataCreateMission.tools.join(', ') || '-'}
      </p>
      <p className="ft-sm">
        <span className="text-gray-700 font-medium">Permis nécessaire :</span>{' '}
        {dataCreateMission.licences.join(', ') || '-'}
      </p>
      <p className="ft-sm">
        <span className="text-gray-700 font-medium">Langue nécessaire :</span>{' '}
        {dataCreateMission.languages.join(', ') || '-'}
      </p>
    </div>
  </div>
);

export default PrerequisitesSection;
